import classNames from 'classnames';

import { Image } from '@jsmdg/yoshi';
import { useProduct } from '../../hooks/useProduct';
import styles from './ImageGallery.module.scss';

const imagesPerRow = 4;

const ImageGalleryFallback = (): JSX.Element | null => {
    const { images, title } = useProduct();

    const firstImage = images[0];

    return (
        <div>
            <div className={classNames('w-100 mx-auto', styles.gallerySwiper)}>
                <div className={styles.swiperSlide}>
                    <Image
                        src={firstImage.src}
                        alt={firstImage.alt || title}
                        srcSet={firstImage.srcset}
                        sizes={firstImage.sizes}
                        className="w-100 h-100 d-block object-fit-cover"
                        lazyLoad={false}
                        fetchpriority="high"
                        width={714}
                        height={470}
                    />
                </div>
            </div>

            <div
                className={classNames(
                    'd-none d-sm-flex flex-nowrap overflow-hidden',
                    styles.thumbnailGallery,
                )}
            >
                {images.slice(0, imagesPerRow).map((image, index) => (
                    <div
                        key={`${String(index)}-thumbnail`}
                        className={classNames(styles.thumbnailSlide, 'mr-1x')}
                    >
                        <Image
                            src={image.thumbnail || image.src}
                            alt={image.alt || title}
                            className={classNames(
                                'w-100 h-100 d-block object-fit-cover',
                                styles.thumbImage,
                            )}
                            width={145}
                            height={95}
                            lazyLoad={false}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export { ImageGalleryFallback };
